import * as React from "react";
import * as moment from "moment";
import { api } from "../../api";
import { observer } from "mobx-react";
import { Alert, Button as ButtonJS, Classes, Dialog, FileInput, FormGroup, HTMLSelect, InputGroup, Spinner } from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { createViewModel, IViewModel } from "mobx-utils";
import { IContador, IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { ContadorDialogStore } from "../../stores/perfil/ContadorDialogStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { mascara_inscricao_estadual, validarCNPJ } from "../../utils";
import { formatCnpj } from "../../utils";
import LoadingModal from "../loading/LoadingModal";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import EmpresaResumo from "./EmpresaResumo";

const BrV = require("br-validations");
const InputMask = require("react-input-mask");

const steps = ['Dados da empresa', 'Tributações de Entrada', 'Segmentos', 'Certificado Digital'];
const stepsRs = ['Dados da empresa', 'Tributações de Entrada', 'Segmentos'];

require("../../assets/css/components/EmpresaForm.css");


interface IEmpresaFormProps {
}

@observer
export default class EmpresaCreateForm extends React.Component<IEmpresaFormProps, any> {
  obs = observable({
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    nome_certificado: "Selecione o certificado" as string,
    certificado: [] as any,
    handleModalCertTeste: false as boolean,
    handleModalConfirm: false as boolean,
    handleModalConfirmRegime: false as boolean,
    pgdas_invalid: false as boolean,
    validando: false as boolean,
    cod_acesso: "" as string,
    contadores_list: [] as IContador[],
    contador_name: "" as string,
    activeStep: 0 as number,
    skipped: 0 as number,
    steps: [] as string[]
  })

  constructor(props: IEmpresaFormProps) {
    super(props);

    AppStore.setTitle("");
    this.obs.empresa = createViewModel(newEmpresa());
  }

  async componentDidMount() {
    if (EmpresaStore.obs.cnpj == "") {
      return AppStore.setLocation("/empresa/plan");
    }

    this.obs.steps = EmpresaStore.obs.empresa.uf == "RS" ? stepsRs : steps

    EmpresaStore.obs.working = false;

    await ContadorDialogStore.handleGetContadores();

    this.obs.contadores_list = ContadorDialogStore.obs.contadores_list;

    this.obs.empresa = createViewModel(newEmpresa());

    this.setState({ filial: "" });

    this.forceUpdate();

    this.obs.empresa.simples_nacional = null;
    this.obs.empresa.regime_especial_icms_pa = null;
    this.obs.empresa.convenio_icms_100_97 = null;
    this.obs.empresa.porta_a_porta = null;

    this.setState({ filial: EmpresaStore.obs.filial });

    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let totalEmpresas = EmpresaStore.obs.count_empresas

    if (contaPermissao && totalEmpresas > 1) {
      return AppStore.setLocation("/empresas");
    }
  }

  handleCheckFilial = (filial: any) => {
    let fil;
    if (filial == "true") {
      fil = true;
    } else {
      fil = false;
    }
    this.setState({ filial: fil });
    this.obs.empresa.filial = fil;
    EmpresaStore.obs.filial = fil;
  };

  handleCheckRegime = (regime: any) => {
    EmpresaStore.obs.regime_importacao = regime.target.value;
    this.obs.handleModalConfirmRegime = true;
  };

  async handleImportCertificado() {

    let senha: string = this.obs.empresa.senha_certificado
    let cnpj: string = EmpresaStore.obs.cnpj
    let filial: boolean = EmpresaStore.obs.filial
    let certificado: any = this.obs.certificado[0]

    var data = new FormData();
    data.append("filial", filial.toString());
    data.append("file", certificado);
    data.append("senha", senha);
    data.append("cnpj", cnpj);

    let resp = await api.post("/api/upload-certificado", data)

    if (resp.data.ok) {

      toast.success('Certificado importado com sucesso', {});

    } else {

      toast.error(resp.data.erro, {});

    }

  }

  handleConfirm = () => {
    this.obs.handleModalConfirm = true;
  };

  handleSave = async () => {

    if (this.state.filial == true) {
      this.obs.empresa.filial = true;
    } else {
      this.obs.empresa.filial = false;
    }

    this.obs.empresa.plano_id = EmpresaStore.obs.valorPlano;

    this.doSave();

  };

  handleSetContador(id: string) {
    for (let i = 0; i < this.obs.contadores_list.length; i++) {
      if (this.obs.contadores_list[i].id == id) {
        this.obs.empresa.contador_responsavel = this.obs.contadores_list[i].id;
        this.obs.contador_name = this.obs.contadores_list[i].nome;
      }
    }
  }

  doSave = async () => {

    if (this.obs.certificado.length > 0) {

      if (this.obs.empresa.senha_certificado == "") {
        toast.error('Preencha a senha do certificado', {});
        return;
      }

    }

    try {

      let isCreated = await EmpresaStore.createEmpresa(this.obs.empresa);

      if (isCreated) {

        if (this.obs.certificado.length > 0) {

          this.handleImportCertificado();

        }

        setTimeout(() => { AppStore.setLocation("/empresas"); window.location.reload(); }, 1000);

      }

    } catch (ex) {

      toast.error(String(ex), {});

    }

    EmpresaStore.setWorking(false);

  };

  handleCancel = () => {
    window.location.href = "/empresa/plan"
  };

  checkSimples(e: any) {
    if (e.target.value == "1") {
      EmpresaStore.obs.simples_nacional = e.target.value;
      EmpresaStore.obs.regime_especial_icms_pa = "";
    } else {
      EmpresaStore.obs.simples_nacional = e.target.value;
      EmpresaStore.obs.simples_nacional_excesso = "";

    }
  }

  handleConfirmRegime = () => {
    this.obs.handleModalConfirmRegime = false;
    let resp = api.get(`/api/confirmar-regime-empresa`);
  };

  handleCancelRegime = () => {
    this.obs.handleModalConfirmRegime = false;
    EmpresaStore.obs.regime_importacao = "";
  };

  dadosEmpresa() {
    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    return (
      <FormGroup>
        <MDBCol>
          <div className="form-step">
            <h2 className="title">Dados da Empresa</h2>
            {!["RS", "PA"].includes(EmpresaStore.obs.empresa.uf) &&
              <p style={{ fontSize: 14, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
                Para o estado atual {EmpresaStore.obs.empresa.uf}, o FIPO fornece apenas os serviços de manifestação de NFe, CTe e NFCe, pois não atendemos este estado nos demais serviços. Para ter todos os serviços funcionando, é necessário estar no estado do PA ou RS.
              </p>
            }
          </div>

          <MDBRow>
            <MDBCol md="6">
              <div className="form-step">
                <FormGroup
                  label="CNPJ"
                  labelFor="cnpj"
                  style={{ width: "100%" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <InputGroup
                    disabled
                    value={formatCnpj(EmpresaStore.obs.cnpj)}
                  />
                </FormGroup>
                <FormGroup
                  label="Razão social"
                  labelFor="razao-social"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <InputGroup
                    id="razao-social"
                    // inputRef={el => this.obs.focusEl = el}
                    defaultValue={EmpresaStore.obs.razao_social}
                    onChange={(e: any) =>
                      EmpresaStore.obs.razao_social = e.target.value}
                  />
                </FormGroup>

                <FormGroup
                  label="Nome fantasia"
                  labelFor="nome-fantasia"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <InputGroup
                    id="nome-fantasia"
                    // inputRef={el => this.obs.focusEl = el}
                    defaultValue={EmpresaStore.obs.nome_fantasia}
                    onChange={(e: any) =>
                      EmpresaStore.obs.nome_fantasia = e.target.value}
                  />
                </FormGroup>

                <FormGroup
                  label="Inscrição Estadual"
                  labelFor="inscricao-estadual"
                >
                  {["RS", "SP", "MG", "PA"].includes(EmpresaStore.obs.empresa.uf) ?
                    <InputMask
                      className="form-control"
                      mask={mascara_inscricao_estadual(EmpresaStore.obs.empresa.uf)}
                      value={EmpresaStore.obs.inscricao_estadual}
                      onChange={(e: any) => EmpresaStore.obs.inscricao_estadual = e.target.value}
                    />
                    :
                    <InputGroup
                      id="inscricao-estadual"
                      value={EmpresaStore.obs.inscricao_estadual}
                      onChange={(e: any) => EmpresaStore.obs.inscricao_estadual = e.target.value}
                    />
                  }
                </FormGroup>

                {!is_teste &&
                  <FormGroup
                    label="Contador Responsável"
                    labelFor="contador"
                    style={{ width: "100%", float: "left" }}
                  >
                    <HTMLSelect
                      onChange={(e) => this.handleSetContador(e.target.value)}
                    >
                      <option value={this.obs.empresa.contador_responsavel} selected>
                        {this.obs.contador_name}
                      </option>
                      {this.obs.contadores_list?.map((el, index) => {
                        return (
                          <option id={index.toString()} value={el.id}>
                            {el.nome}
                          </option>
                        );
                      })}
                    </HTMLSelect>

                    {!this.obs.contadores_list.length &&
                      (
                        <span>
                          Você pecisar acessar o perfil e cadastrar um{" "}
                          <b>Contador</b>
                        </span>
                      )}
                  </FormGroup>

                }
              </div>
            </MDBCol>

            <MDBCol md="6">
              <div className="form-step">
                <FormGroup
                  label="Regime da Empresa"
                  labelFor="regime"
                  style={{ width: "48%", float: "left" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect
                    onChange={this.handleCheckRegime.bind(this)}
                    value={EmpresaStore.obs.regime_importacao}
                    id="regime"
                  >
                    <option value="">SELECIONE</option>
                    <option value="CAIXA">CAIXA</option>
                    <option value="COMPETÊNCIA">COMPETÊNCIA</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Tipo de Cadastro"
                  labelFor="tipo"
                  style={{ width: "48%", float: "right" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect
                    onChange={(e) => this.handleCheckFilial(e.target.value)}
                    id="TipoEmpresa"
                    disabled
                  >
                    <option value="">Selecione</option>
                    <option value="false" selected={!EmpresaStore.obs.filial}>MATRIZ</option>
                    <option value="true" selected={EmpresaStore.obs.filial}>FILIAL</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Município"
                  labelFor="municipio"
                  style={{ width: "48%", float: "left" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect disabled id="municipio">
                    <option selected value={EmpresaStore.obs.empresa.municipio}>{EmpresaStore.obs.empresa.municipio}</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Estado"
                  labelFor="estado"
                  style={{ width: "48%", float: "right" }}
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                >
                  <HTMLSelect disabled id="estado">
                    <option selected value={EmpresaStore.obs.empresa.uf}>{EmpresaStore.obs.empresa.uf}</option>
                  </HTMLSelect>
                </FormGroup>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </FormGroup>
    )
  }

  tributacaoEmpresa() {
    return (
      <>
        <div style={{ width: 1000 }}>
          <MDBCol md="12">
            <div className="form-step">
              <h2 className="title">Tributações de Entrada</h2>
              <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
                Atenção! É importante você selecionar as informações
                corretas das tributações, pois elas interferem diretamente
                no cálculo.
              </p>
              <FormGroup
                labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                label="Regime Simples Nacional">
                <HTMLSelect
                  onChange={e => this.checkSimples(e)}
                  value={EmpresaStore.obs.simples_nacional}
                  id="TributacaoSelect1"
                  required
                >
                  <option value="Selecione" selected>Selecione</option>
                  <option value="">Não</option>
                  <option value="1">Sim</option>
                </HTMLSelect>
              </FormGroup>

              {EmpresaStore.obs.simples_nacional == "1" &&
                <FormGroup
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}
                  label="Excesso de Sublimite de Receita Bruta">
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.simples_nacional_excesso = e.target.value }}
                    value={EmpresaStore.obs.simples_nacional_excesso}
                    id="TributacaoSelect6"
                  >
                    <option value="Selecione" selected>Selecione</option>
                    <option value="">Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

              }
              <FormGroup
                label="Regime Especial"
                labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                <HTMLSelect
                  onChange={e => { EmpresaStore.obs.regime_especial_icms_pa = e.target.value }}
                  value={EmpresaStore.obs.regime_especial_icms_pa}
                  id="TributacaoSelect2"
                  disabled={EmpresaStore.obs.simples_nacional === "1"}
                >
                  <option value="Selecione" selected={EmpresaStore.obs.simples_nacional ? false : true}>Selecione</option>
                  <option value="" selected={EmpresaStore.obs.simples_nacional ? true : false}>Não</option>
                  <option value="1">Sim</option>
                </HTMLSelect>
              </FormGroup>

              <FormGroup
                label="Convênio ICMS 100/97"
                labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                <HTMLSelect
                  onChange={e => { EmpresaStore.obs.convenio_icms_100_97 = e.target.value }}
                  value={EmpresaStore.obs.convenio_icms_100_97}
                  id="TributacaoSelect3"
                >
                  <option value="Selecione" selected>Selecione</option>
                  <option value="">Não</option>
                  <option value="1">Sim</option>
                </HTMLSelect>
              </FormGroup>

              <FormGroup
                label="Operação de Venda na Modalidade Porta a Porta"
                labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                <HTMLSelect
                  onChange={e => { EmpresaStore.obs.porta_a_porta = e.target.value }}
                  value={EmpresaStore.obs.porta_a_porta}
                  id="TributacaoSelect7"
                >
                  <option value="Selecione" selected>Selecione</option>
                  <option value="">Não</option>
                  <option value="1">Sim</option>
                </HTMLSelect>
              </FormGroup>
            </div>
          </MDBCol>
        </div>
      </>
    )
  }

  segmentosEmpresa() {
    return (
      <>
        <MDBCol>
          <div className="form-step">
            <h2 className="title">Segmentos da empresa</h2>

            <p style={{ fontSize: 16, fontWeight: "bold", textAlign: "justify", color: "#d95050" }}>
              Atenção! É importante você selecionar as informações corretas dos segmentos.
            </p>
            <br />
          </div>
          <MDBRow>
            <MDBCol md="6">
              <div>
                <FormGroup
                  label="Comercializa tintas e vernizes"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_tintas = e.target.value }}
                    value={EmpresaStore.obs.seg_tintas}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa medicamentos de uso humano e outros produtos farmacêuticos"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_medicamentos_humano = e.target.value }}
                    value={EmpresaStore.obs.seg_medicamentos_humano}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa produtos de material de construção"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_mat_construcao = e.target.value }}
                    value={EmpresaStore.obs.seg_mat_construcao}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>
                <FormGroup
                  label="Comercializa produtos veterinário/pet"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_vet_pet = e.target.value }}
                    value={EmpresaStore.obs.seg_vet_pet}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa produtos de autopeças"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_auto_pecas = e.target.value }}
                    value={EmpresaStore.obs.seg_auto_pecas}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa refrigerantes"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_refrigerantes = e.target.value }}
                    value={EmpresaStore.obs.seg_refrigerantes}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa águas e outras bebidas"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_agua_out = e.target.value }}
                    value={EmpresaStore.obs.seg_agua_out}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa lâmpadas, reatores e starter"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_lamp_reatores = e.target.value }}
                    value={EmpresaStore.obs.seg_lamp_reatores}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa materiais de limpeza"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_mat_limpeza = e.target.value }}
                    value={EmpresaStore.obs.seg_mat_limpeza}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>
              </div>
            </MDBCol>
            <MDBCol md="6">
              <div>
                <FormGroup
                  label="Comercializa produtos pneumáticos, câmaras de ar e protetores de borracha"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_pneumaticos_prot = e.target.value }}
                    value={EmpresaStore.obs.seg_pneumaticos_prot}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa produtos alimentícios"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_alimenticios = e.target.value }}
                    value={EmpresaStore.obs.seg_alimenticios}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa produtos de perfumaria e de higiene pessoal e cosméticos"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_perf_cosm = e.target.value }}
                    value={EmpresaStore.obs.seg_perf_cosm}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa rações para animais domésticos"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_racoes = e.target.value }}
                    value={EmpresaStore.obs.seg_racoes}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa produtos eletrônicos, eletroeletrônicos e eletrodomésticos"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_eletro = e.target.value }}
                    value={EmpresaStore.obs.seg_eletro}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa sorvetes e preparados para fabricação de sorvetes em máquinas"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_sorvetes_fab = e.target.value }}
                    value={EmpresaStore.obs.seg_sorvetes_fab}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>
              </div>
              <div>

                <FormGroup
                  label="Comercializa veículos automotores novos"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_veiculos_automotores = e.target.value }}
                    value={EmpresaStore.obs.seg_veiculos_automotores}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>

                <FormGroup
                  label="Comercializa veículos novos de duas e três rodas motorizados"
                  labelInfo={<span style={{ color: "#d95050" }}>*</span>}>
                  <HTMLSelect
                    onChange={e => { EmpresaStore.obs.seg_veiculos_novos = e.target.value }}
                    value={EmpresaStore.obs.seg_veiculos_novos}
                  >
                    <option value="" selected>Não</option>
                    <option value="1">Sim</option>
                  </HTMLSelect>
                </FormGroup>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </>
    )
  }

  certificadoEmpresa() {
    const handleFileInputChange = (event) => {
      const file = event.target.files[0];

      this.obs.nome_certificado = file.name
      this.obs.certificado = event.target.files

    };
    return (
      <>
        <MDBCol>

          <div className="form-step" style={{ width: 500 }}>
            <h2 className="title">Certificado Digital (A1)</h2>
            <br />

            <FormGroup label="Selecionar Certificado Digital" labelFor="certificado">
              <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={handleFileInputChange} />
            </FormGroup>

            <FormGroup label="Senha Certificado">
              <InputGroup type="password" onChange={(e: any) => this.obs.empresa.senha_certificado = e.target.value} value={this.obs.empresa.senha_certificado} />
            </FormGroup>
          </div>
        </MDBCol>

      </>
    )

  }

  render() {

    const HorizontalLinearStepper = () => {

      const isStepOptional = (step: number) => {
        return step === 3;
      };

      const handleNext = () => {
        this.obs.activeStep = this.obs.activeStep + 1
      };

      const handleBack = () => {
        this.obs.activeStep = this.obs.activeStep - 1
      };

      return (
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={this.obs.activeStep}>
            {this.obs.steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (isStepOptional(index)) {
                labelProps.optional = (
                  <Typography variant="caption">Opcional</Typography>
                );
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <React.Fragment>
            {this.obs.activeStep == 0 && this.dadosEmpresa()}
            {this.obs.activeStep == 1 && this.tributacaoEmpresa()}
            {this.obs.activeStep == 2 && this.segmentosEmpresa()}
            {this.obs.activeStep == 3 && this.certificadoEmpresa()}
            <MDBCol>
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                {this.obs.activeStep > 0 ?
                  <ButtonJS
                    color="inherit"
                    onClick={handleBack}
                  // sx={{ mr: 1 }}
                  >
                    Voltar
                  </ButtonJS>
                  :
                  <ButtonJS
                    text="Cancelar"
                    onClick={this.handleCancel}
                    className="btnCancelEmp"
                    disabled={EmpresaStore.obs.working}
                  />
                }

                <Box sx={{ flex: '1 1 auto' }} />
                {this.obs.activeStep === this.obs.steps.length - 1
                  ? <ButtonJS className="btnCadastraEmp" onClick={this.handleConfirm} loading={EmpresaStore.obs.working}>
                    {'Cadastrar Empresa'}
                  </ButtonJS>
                  :
                  <ButtonJS onClick={handleNext} className="btnCadastraEmp">
                    {'Próximo'}
                  </ButtonJS>
                }
              </Box>
            </MDBCol>
          </React.Fragment>
        </Box>
      );
    }

    return (
      <>
        {HorizontalLinearStepper()}

        <div style={{ marginBottom: 120 }} />

        <LoadingModal open={this.obs.validando} onClose={() => this.obs.validando = false} title={"Validando PGDAS"} />

        <Dialog
          isOpen={this.obs.handleModalConfirmRegime}
          title="Atenção"
          onClose={() => this.handleCancelRegime()}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Regime Selecionado: {EmpresaStore.obs.regime_importacao}
                </h3>
                <h3 className="titleProccess">
                  O regime selecionado irá impactar o resultado dos cálculos
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Certifique-se que realmente este é o regime da sua empresa.
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>
            <ButtonJS
              onClick={() => this.handleCancelRegime()}
              className="cancelCadEmp"
            >
              Cancelar
            </ButtonJS>
            <ButtonJS
              onClick={() => this.handleConfirmRegime()}
              className="certiDigitalTeste"
            >
              Sim, este é o Regime
            </ButtonJS>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.obs.handleModalConfirm}
          title="Confirme os dados e conclua o cadastro"
          onClose={() => this.obs.handleModalConfirm = false}
          style={{ width: 700 }}
          className="confirmCadEmp"
        >
          <div className={Classes.DIALOG_BODY}>
            <EmpresaResumo doSave={this.handleSave.bind(this)} onClose={() => this.obs.handleModalConfirm = false} />
          </div>
        </Dialog>
        <Dialog
          isOpen={this.obs.handleModalCertTeste}
          title="Certificado Digital"
          onClose={() => this.obs.handleModalCertTeste = false}
          style={{ width: 700 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <br />
            <br />
            <div className="icon-warning-dialog">
              <img src="/images/calendar.svg" width="120px;" />
            </div>
            <h3 className="titleProccess">
              Com o certificado digital cadastrado, você ganha inúmeros
              benefícios.
            </h3>
            <p>
              Tendo o Certificado Digital em mãos, A FIPO dispobiliza o módulo
              {" "}
              <b>Manifestação de NF-es</b>
            </p>
            <p style={{ lineHeight: "24px" }}>
              Com ele, sincronizamos os dados da sua empresa em conjunto com a
              Secretaria da Fazenda <br />
              através dos webservices oficiais disponibilizados pelo governo,
              que permitem a consulta,<br /> monitoramento e download de
              <b>NF-es</b> sem depender de chave de acesso e com a{" "}
              <br />segurança de receber todos os documentos.
            </p>
            <br />
            <p>
              <b>* Módulo não disponível em período de teste.</b>
            </p>
            <ButtonJS
              onClick={(e) => AppStore.setLocation("/historico-notas")}
              className="certiDigitalTeste"
            >
              Veja uma Demonstração
            </ButtonJS>
          </div>
        </Dialog>
      </>
    );
  }
}
